<div class="field">
  <label for="make-select">Make</label>
  <ng-select
    id="make-select"
    [items]="makes()"
    bindLabel="name"
    bindValue="id"
    [virtualScroll]="true"
    [bufferAmount]="20"
    [searchable]="true"
    [clearable]="true"
    [loading]="loading()"
    [placeholder]="loading() ? 'Loading makes…' : 'Select a make'"
    [formControl]="control" />
  @if (error()) {
    <p class="field-error">{{ error() }}</p>
  }
</div>
